import { render, staticRenderFns } from "./InterfaceLLDPFacts.vue?vue&type=template&id=61b1a98a&scoped=true&"
import script from "./InterfaceLLDPFacts.vue?vue&type=script&lang=ts&"
export * from "./InterfaceLLDPFacts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b1a98a",
  null
  
)

export default component.exports